<template>
    <!-- <v-card class="mx-auto"  height="100vh" width="300"> -->
    <div id="NavRight">
        <div v-if="stay">
            <v-navigation-drawer right v-model="RightDrawer" height="100vh" app dark color="grey darken-4" temporary>

                <v-divider></v-divider>
                <v-list>
                </v-list>
            </v-navigation-drawer>
        </div>

        <div v-else>
            <v-navigation-drawer  right height="100vh" app dark color="grey darken-4" permanent>

                <v-divider></v-divider>
                <v-list>
                </v-list>
            </v-navigation-drawer>
        </div>

    </div>

    <!-- </v-card> -->
</template>

<script>
    export default {
        props: {
            RightDrawer: Boolean,
            stay: Boolean
        },
        data: () => ({

        })
    }
</script>